import React from "react";
import styles from "./Card.module.scss";

interface Props {
  children: string | JSX.Element;
  className?: string;
}

const Card = ({ children, className = "" }: Props): JSX.Element => <div className={`${styles.card} ${className}`.trim()}>{children}</div>;

export default Card;
